import { render, staticRenderFns } from "./ChangeBandwidth.vue?vue&type=template&id=16639e5b"
import script from "./ChangeBandwidth.vue?vue&type=script&lang=js"
export * from "./ChangeBandwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports